<template>
  <section v-if="chatbot">
    <b-modal width="680px" :active.sync="isModalDeleteActive" :on-cancel="cancel">
      <div class="card" style="border-radius: 5px;">
        <header class="card-header">
          <p class="card-header-title">
            {{ chatbot.name }}を本当に削除してもよろしいでしょうか？
          </p>
        </header>
        <div class="card-content">
          <p>
            <b-message type="is-danger" has-icon>
              削除されたロボを復元することはできません。
              削除の際は細心の注意を払って削除をお願いいたします。
            </b-message>
          </p>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" @click="cancel()">いいえ</a>
          <a class="card-footer-item" @click="deleteChatBot()">はい</a>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import controlLogMixin from '@/mixins/controlLogMixin'
export default {
  name: 'ModalDeleteChatBot',
  componentName: 'ModalDeleteChatBot',
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('chatbot', ['chatbots']),
    ...mapState('auth', ['user']),
    chatbot () {
      let ret = null
      for (const cb of this.chatbots) {
        if (cb.bot_id === this.deleteIndex) {
          ret = cb
          break
        }
      }
      return ret
    }
  },
  props: {
    deleteIndex: {
      type: String,
      require: true
    },
    isShowModal: {
      type: Boolean,
      default: false,
      require: true
    }
  },
  data () {
    return {
      chatBotDeleteFlag: false,
      isModalDeleteActive: this.isShowModal,
    }
  },
  methods: {
    cancel () {
      this.$emit('cancel')
    },
    deleteChatBot () {
      this.sendControlLogRelatedChatBot('ロボ削除', 'ロボ詳細画面にて、ロボを削除した。', this.chatbot)
      this.chatBotDeleteFlag = false
      this.$store.dispatch('chatbot/deleteChatBot', { companyid: this.user.companyID, chatbotID: this.deleteIndex })
      this.$emit('deleteComplete')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components2/Robo/modal/ModalDeleteChatBot.vue